import swal from 'sweetalert';
import { getMetaValue } from './utilities/browser.js';

const SESSION_TIMEOUT = 30 * 60 * 1000 - 2000; // 30 minutes - 2s for possible page load

function initSession() {
    let startTime = Number(getMetaValue('start'));

    function redirect() {
        const pathname = window.location.pathname;

        if (pathname.startsWith('/legal-entity')) {
            window.location.href = '/legal-entity/authentication';
        } else {
            window.location.href = '/';
        }
    }

    function getSecondsRemaining() {
        const currentTime = new Date().getTime();
        const elapsedTime = currentTime - startTime;
        const remainingTime = SESSION_TIMEOUT - elapsedTime;

        return Math.max(0, Math.floor(remainingTime / 1000));
    }

    function showTimeoutWarning() {
        const content = document.createElement('div');
        content.innerText = 'Informuojame, kad Jūsų sesija netrukus baigsis. Iki sesijos pabaigos liko: ';
        const timer = document.createElement('div');
        timer.style.fontSize = '24px';
        timer.style.fontWeight = 'bold';
        timer.innerText = `${getSecondsRemaining()} sek.`;
        content.appendChild(timer);

        const timerInterval = setInterval(() => {
            const secondsRemaining = getSecondsRemaining();
            timer.innerText = `${secondsRemaining} sek.`;

            if (secondsRemaining <= 0) {
                clearInterval(timerInterval);

                swal({
                    title: 'Dėmesio!',
                    text: 'Jūsų sesijos laikas baigėsi!',
                    icon: 'error',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    button: {
                        text: 'Pildyti iš naujo',
                        closeModal: false,
                    },
                    // eslint-disable-next-line arrow-body-style
                }).then(() => {
                    return fetch('/ping?cancel=1').then(() => {
                        redirect();
                    });
                });
            }
            // interval of 1000 acts weird in webkit? sometimes hangs up and skips a second.
            // lower internal sometimes lags too but at least doesn't skip seconds
        }, 250);

        swal({
            title: 'Dėmesio!',
            content: content,
            icon: 'warning',
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
                continue: {
                    text: 'Tęsti pildymą',
                    value: true,
                    closeModal: false,
                },
            },
        }).then((result) => {
            if (!result) {
                return null;
            }

            if (result === 'end') {
                return fetch('/ping?cancel=1').then(() => {
                    redirect();
                });
            }

            return fetch('/ping')
                .then(response => response.json())
                .then((data) => {
                    startTime = data.start;

                    clearInterval(timerInterval);
                    swal.close();
                });
        });
    }

    function startTimer() {
        const checkSession = setInterval(() => {
            const secondsRemaining = getSecondsRemaining();
            if (secondsRemaining <= 60) {
                clearInterval(checkSession);

                showTimeoutWarning();
            }
        }, 1000);
    }

    startTimer();
}

export default initSession;
